export default __webpack_public_path__ + "static/media/activities.3a82d05c.jpg";